import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { BaseRouteParams } from 'hocs'
import { AppServices } from 'middleware'
import { PricingPlansContainer, PricingPlan } from 'products/pricing/pricingPlans'
import { TableLoader } from 'uiComponents/loaders'
import { showErrorMessage } from 'uiComponents/message'
import { useTranslation } from 'translations'

interface ProductPricingPlansProps {
    articleUuid: string
    readOnly?: boolean
}

export const ProductPricingPlans = ({ articleUuid, readOnly }: ProductPricingPlansProps) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const [pricingPlans, setPricingPlans] = useState<PricingPlan[]>([])
    const [loading, setLoading] = useState(true)

    const fetchPricingPlans = useCallback(async () => {
        setLoading(true)
        try {
            const response = await AppServices.pricingPlansService.getPricingPlans(accountSlug, articleUuid)
            setPricingPlans(response.items ?? [])
        } catch (error) {
            showErrorMessage(t('memberships.productsList.pricingPlansLoadError'))
            setPricingPlans([])
        }
        setLoading(false)
    }, [accountSlug, articleUuid, t])

    useEffect(() => {
        fetchPricingPlans()
    }, [])

    if (loading) {
        return <TableLoader />
    }

    return (
        <PricingPlansContainer
            pricingPlans={pricingPlans}
            pricingPlansService={AppServices.pricingPlansService}
            accountSlug={accountSlug}
            articleUuid={articleUuid}
            onUpdate={fetchPricingPlans}
            readOnly={readOnly}
        />
    )
}

